import type { HtmlType, NameAndType } from '../../types.js'
import type { TsCodeType } from '../../types.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { LeafBlock } from '../leaf-block.js'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import { TextOrExpression_assumeExpression } from '../../data/text-or-code.js'
import {
	type HtmlMode,
	HtmlModes,
	type TextBlockStyle,
	TextBlockStyleNames,
} from '../../consts.js'

@jsonClass('TextBlock')
export class TextBlock extends LeafBlock {
	@jsonProperty(TextOrExpression_assumeExpression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 1,
		label: 'Text',
		codeLanguage: 'ts',
		tsReturnType: () => 'string | number',
		editorSize: 'singleline',
		isBinding: false,
		isMandatory: () => true,
	})
	textCode = new TextOrExpression_assumeExpression('', 'T')

	@jsonProperty(String)
	@ScreenEditorInput({
		inputType: 'dropdown',
		order: 2,
		label: 'Style',
		options: Object.entries(TextBlockStyleNames),
		isBinding: false,
	})
	style: TextBlockStyle = 'span'

	@jsonProperty(String)
	@ScreenEditorInput({
		inputType: 'dropdown',
		order: 10,
		label: 'Allow HTML (CAREFUL!)',
		tab: 'Advanced',
		options: Object.entries(HtmlModes),
		tooltip: () => ({
			text: 'Only use UNSAFE HTML if you absolutely have to and <b></b>',
			acceptHtml: true,
		}),
	})
	htmlMode: HtmlMode = 'none'

	canAcceptVariableString = (variable: NameAndType) => true
	acceptVariableString = (variable: NameAndType) =>
		(this.textCode = new TextOrExpression_assumeExpression(variable.name))

	constructor(
		init:
			| Partial<TextBlock>
			| { text: string }
			| { expression: string }
			| { code: string } = {},
	) {
		super()

		if ('text' in init) {
			this.textCode.set(init.text, 'T')
		} else if ('expression' in init) {
			this.textCode.set(init.expression, 'E')
		} else if ('code' in init) {
			this.textCode.set(init.code, 'C')
		} else {
			this.init(init)
		}
	}

	producePreview(): HtmlType {
		if (this.exampleText) {
			return this.transpileExpressionForHtml(this.exampleText)
		}
		if (this.textCode.content) {
			return this.transpileExpressionForHtml(this.textCode.content)
		}
		return `<span class="example">${this.exampleText}</span>`
	}

	getEditorCategory(): string {
		return 'Core'
	}
}
